import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import useStyles from "./style";
import _ from "lodash";
import { useDispatch } from "react-redux";

//Tabs

//Modals
import TestModal from "Pages/Modals/TestModal";

const TestPage = () => {
  const classes = useStyles();

  const [testModal, setTestModal] = useState(false);

  const handleOpenTestModal = () => {
    setTestModal(true);
  };

  const handleCloseTestModal = () => {
    setTestModal(false);
  };

  return (
    <>
      <Grid item xs={12} md={12} lg={12} xl={12} className={classes.addBtn}>
        <Button variant="contained" onClick={handleOpenTestModal}>
          Test Modal
        </Button>
      </Grid>
      <TestModal
        openDialog={testModal}
        handleClose={handleCloseTestModal}
      ></TestModal>
    </>
  );
};

export default TestPage;
